import { getWishlist, onWishlistChange } from '@theme/wishlist';

/**
 * Shows how many products are in the wishlist (hidden when empty).
 */
class WishlistCount extends HTMLElement {
  /** @type {(() => void) | undefined} */
  #unsubscribe;

  connectedCallback() {
    this.#unsubscribe = onWishlistChange(this.#render);
    this.#render(getWishlist());
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
  }

  /** @param {string[]} handles */
  #render = (handles) => {
    const count = handles.length;
    this.textContent = count > 99 ? '99+' : String(count);
    this.hidden = count === 0;
  };
}

if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount);
}
